@use '../../../../../styles/Constants.scss' as Constants;
@use '../../../../../styles/Colors.scss' as Colors;

.resource-container {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-s;
}

.resource-header-container {
	background-color: Colors.$col-white;
	display: flex;
	flex-flow: row;
	justify-content: space-between;
	padding: Constants.$val-spacing-m Constants.$val-spacing-l;
}

.resource-header-title {
	font-size: Constants.$val-fontSizeXBig;
	text-transform: uppercase;
	font-weight: 500;
}

.resource-btn-container {
	display: flex;
	gap: Constants.$val-spacing-s;
}

.work-orders-container {
	background-color: Colors.$col-white;
}